import React, { useMemo, useState } from "react";
import { useAuthentication } from "../../context/authentication";
import { Entity } from "../../utils/constants";
import { LabelFilterKey } from "../../utils/useFilteredLabels";
import DisplayLabels from "./DisplayLabels";
import EditLabels from "./EditLabels";

interface Props {
  className?: string;
  entity: Entity;
  linkedUuid: string;
  contextWalletAddresses?: string[];
  filterKey: LabelFilterKey;
}

const Labels: React.FC<Props> = ({
  className,
  entity,
  linkedUuid,
  contextWalletAddresses = [],
  filterKey
}) => {
  const [showEditLabels, setShowEditLabels] = useState(false);
  const { wrapActionWithAuth } = useAuthentication();

  const toggleEditing = wrapActionWithAuth(() =>
    setShowEditLabels((prevShowEditLabels) => !prevShowEditLabels)
  );

  const renderDisplayLabes = useMemo(
    () => (
      <DisplayLabels
        linkedUuid={linkedUuid}
        toggleEditing={toggleEditing}
        contextWalletAddresses={contextWalletAddresses}
        filterKey={filterKey}
      />
    ),
    [contextWalletAddresses, filterKey, linkedUuid, toggleEditing]
  );

  const renderEditLabels = useMemo(
    () => (
      <EditLabels
        entity={entity}
        linkedUuid={linkedUuid}
        onClose={toggleEditing}
      />
    ),
    [entity, linkedUuid, toggleEditing]
  );

  return (
    <div className={className}>
      {showEditLabels ? renderEditLabels : renderDisplayLabes}
    </div>
  );
};

export default Labels;
